export default "__VITE_ASSET__BQEQVsr1__"